import { Checkbox } from '../ui/checkbox';

interface MarketingConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled: boolean;
}

export function MarketingConsentCheckbox({
  checked,
  onChange,
  disabled,
}: MarketingConsentCheckboxProps) {
  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id="marketing-opt-in"
        checked={checked}
        onCheckedChange={value => onChange(value === true)}
        disabled={disabled}
      />
      <label htmlFor="marketing-opt-in" className="font-body text-sm leading-5 text-night-900">
        I agree that CareCal may feature my profile in marketing materials, including on social
        media, and may share links to my profile.
      </label>
    </div>
  );
}
